import { TableauService } from '@tableau/tableau.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@base/http-client';
import { ICompany } from '@company/company.structures';
import { ITableauGroup, IErrorResponse, ITag } from '@interfaces';
import { ExceptionService } from '@exceptions-service';

const moduleRoutes = {
    base: 'tags/',
    getMultiples: 'tags/get-multiples/',
    sync: 'tags/synchronize-tableau',
};

@Injectable()
export class TagService {
  private _mapRoutes = moduleRoutes;
  private _tag: ITag;
  _company: ICompany;

  private tagsState: ITag[] = [];
  private bsTagsState = new BehaviorSubject<ITag[]>(this.tagsState);

  constructor(
    private http: ApplicationHttpClient,
    private exceptionService: ExceptionService,
    private tableauService: TableauService,
  ) { }

//   getTags(): Observable<IGroupList> {
//     return this.http.Get(this._mapRoutes.base);
//   }

  getTag(id: number): Observable<ITag> {
    return this.http.Get(`${this._mapRoutes.base}${id}/`);
  }

  loadTags() {
    this.http.Get(this._mapRoutes.base).subscribe(
      (res) => {
        this.tagsState = res['results'];
        this.bsTagsState.next(this.tagsState);
      },
      (err: HttpErrorResponse) => { const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );
  }

  addTag(tag: ITag) {
    this.tagsState = [...this.tagsState, tag];
    this.bsTagsState.next(this.tagsState);
  }

  createTag(tag: ITag): Observable<ITag> {
    tag['company'] = tag['companyId'];
    return this.http.Post(this._mapRoutes.base, tag);
  }

  updateTag(tag: ITag): Observable<any> {
    return this.http.Put(`${this._mapRoutes.base}${tag.id}/`, tag);
  }

  deleteTag(tag: ITag): Observable<any> {
    return this.http.Delete(`${this._mapRoutes.base}${tag.id}/`);
  }

  getMultiples(payload: object): Observable<ITag[]> {
    return this.http.Post(`${this._mapRoutes.getMultiples}`, payload);
  }

  observeTags(): Observable<ITableauGroup[]> {
    return this.bsTagsState.asObservable();
  }
}
